import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./css/mackdown.css";

interface Props {
    content: string;
}

export default function MarkdownMessage({ content }: Props) {
    return (
        <div className="markdown-message">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
            </ReactMarkdown>
        </div>
    );
}
